"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxesWidget = exports.deselectValue = exports.selectValue = exports.arraysMatch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_flowright_1 = __importDefault(require("lodash.flowright"));
const surface_1 = require("../../../../../../surface");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
const checkboxes_style_1 = __importDefault(require("./checkboxes.style"));
/**
 * Utils
 */
const arraysMatch = (arr1, arr2) => {
    for (let i = 0; i < arr1.length; i += 1) {
        if (!arr2.includes(arr1[i]))
            return false;
    }
    return true;
};
exports.arraysMatch = arraysMatch;
const selectValue = (value, selected, all) => {
    const updated = [...selected, value];
    // As inserting values at predefined index positions doesn't work with empty
    // arrays, we need to reorder the updated selection to match the initial order
    const sorted = updated.sort((a, b) => all.indexOf(a) > all.indexOf(b) ? 1 : -1);
    return sorted;
};
exports.selectValue = selectValue;
const deselectValue = (value, selected) => selected.filter(v => v !== value);
exports.deselectValue = deselectValue;
/**
 * Widget Component
 */
const CheckboxesWidget = props => {
    const { classes, disabled, options: { enumOptions, enumDisabled, inline = false }, value, readonly, onChange, id, formContext } = props;
    /**
     * Building an array of string values
     * in order to match with an array of results values.
     */
    const enumOptionsValues = Object.values(enumOptions).map(e => e.value);
    const [tempEnumOptions, setTempEnumOptions] = react_1.default.useState(enumOptionsValues);
    /**
     * Check if the selectMenu option value has changed.
     * If so, we clear the array of results values.
     */
    if (!exports.arraysMatch(enumOptionsValues, tempEnumOptions)) {
        setTempEnumOptions(enumOptionsValues);
        onChange([]);
    }
    const handleSingleCheck = (event, optionValue) => {
        const all = enumOptions.map(({ value }) => value);
        if (event.target.checked) {
            return onChange(exports.selectValue(optionValue, value, all));
        }
        return onChange(exports.deselectValue(optionValue, value));
    };
    const handleAllChecked = () => {
        const all = enumOptions.map(({ value }) => value);
        if (exports.arraysMatch(enumOptionsValues, value)) {
            return onChange([]);
        }
        return onChange(all);
    };
    const rootProps = {
        className: classes.root,
        'data-is-inline': inline
    };
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    const allDisabled = disabled || readonly || isLocked;
    return (jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [enumOptions.length > 1 && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.selectAllCheck }, { children: jsx_runtime_1.jsx(surface_1.Check, { showLabel: true, checked: exports.arraysMatch(enumOptionsValues, value), disabled: allDisabled, handleChange: handleAllChecked, label: "Select all", darkLabel: true, largeLabel: true, bold: true }, void 0) }), void 0)),
            enumOptions.map(({ value: optionValue, label }) => {
                const checked = value.indexOf(optionValue) !== -1;
                const itemDisabled = enumDisabled && enumDisabled.indexOf(optionValue) !== -1;
                return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.checkboxWrapper }, { children: jsx_runtime_1.jsx(surface_1.Check, { showLabel: true, checked: checked, disabled: allDisabled || itemDisabled, handleChange: e => handleSingleCheck(e, optionValue), label: label, darkLabel: true, largeLabel: true }, void 0) }), optionValue));
            })] }), void 0));
};
exports.CheckboxesWidget = CheckboxesWidget;
exports.default = lodash_flowright_1.default(withInlineValidation_1.default, react_jss_1.default(checkboxes_style_1.default))(exports.CheckboxesWidget);
//# sourceMappingURL=index.js.map